import React from 'react';
import moment from 'moment';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Grid,
  Step,
  Button
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';

import {FormattedMessage} from 'react-intl';
import appPreview from '../img/app_preview.png';
import Counter from './Counter';

const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            content='App'
            inverted
            style={{
            fontSize: mobile ? '2em' : '4em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        />
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.7em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.apppage.header.text"/>
        </Header>
        
        </Container>
    </Segment>
)


let releaseDate = moment('2020-11-30 09:00:00');
let currentDate = moment();

const diff = releaseDate.diff(currentDate);
const diffDuration = moment.duration(diff);

const handleMailTo = () => {
    const email = 'max.rose@audory.io';
    let subject = 'Beta-Tester für die audory-App';
    let body = `Hallo Max,
      
ich würde euch gerne helfen und die audory-App schon vor der Veröffentlichung als Beta-Tester testen und Feedback geben.
      
Mit freundlichen Grüßen
NAME
    `;
    subject = encodeURIComponent(subject);
    body = encodeURIComponent(body);
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  }

const AppPage = () => (
  <DivWrapper>
      <PageHeader />
    <Segment style={{ padding: '3em 0em', margin: 0 }}>
        
        <Container text>

            <Grid textAlign='center'>
                <Grid.Row only='computer' columns={1} style={{marginBottom: '1em'}}>
                    <Header as='h2' style={{ fontSize: '1.8em', textAlign: 'center' }}>
                        <FormattedMessage id="audory.apppage.body.head2"/>
                    </Header>
                </Grid.Row>
                <Grid.Row only='mobile tablet' columns={1}>
                    <Header as='h4' style={{ fontSize: '1.2em', textAlign: 'center' }}>
                        <FormattedMessage id="audory.apppage.body.head2"/>
                    </Header>
                </Grid.Row>
            </Grid>
            

            <Grid columns={3} style={{margin: '0.5em 0.3em', marginTop: '0em'}}>
                <Grid.Column textAlign='center'>
                    <Counter
                        singular='audory.apppage.body.month'
                        plural='audory.apppage.body.months'
                        value={diffDuration.months()}
                    />
                </Grid.Column>
                <Grid.Column>
                    <Counter
                        singular='audory.apppage.body.day'
                        plural='audory.apppage.body.days'
                        value={diffDuration.days()}
                    />
                </Grid.Column>
                <Grid.Column>
                    <Counter
                        singular='audory.apppage.body.hour'
                        plural='audory.apppage.body.hours'
                        value={diffDuration.hours()}
                    />
                </Grid.Column>
            </Grid>
            {
                /*
<p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.apppage.body.body2"/>
            </p>
                */
            }
            

            <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify' }}>
                <FormattedMessage id="audory.apppage.body.head"/>
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '3em' }}>
                <FormattedMessage id="audory.apppage.body.body"/>
            </p>

            <Step.Group fluid widths={3}>
                <Step>
                    <Icon name='tasks' />
                    <Step.Content>
                        <Step.Title>
                            <FormattedMessage id="audory.apppage.body.step1"/>
                        </Step.Title>
                    </Step.Content>
                </Step>
                <Step>
                    <Icon name='bug' />
                    <Step.Content>
                        <Step.Title>
                            <FormattedMessage id="audory.apppage.body.step2"/>
                        </Step.Title>
                    </Step.Content>
                </Step>
                <Step active>
                    <Icon name='upload' />
                    <Step.Content>
                        <Step.Title>
                            <FormattedMessage id="audory.apppage.body.step3"/>
                        </Step.Title>
                    </Step.Content>
                </Step>
            </Step.Group>

            
            
            <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '2em' }}>
                <center><Image src={appPreview} size='huge' /></center>
                <Segment basic>
                    <Grid columns={2} relaxed='very'>
                    <Grid.Column>
                        <center><Icon name='android' size='huge' /></center>
                    </Grid.Column>
                    <Grid.Column>
                        <center><Icon name='apple' size='huge' /></center>
                    </Grid.Column>
                    </Grid>
                </Segment>
            </Header>

            
            {
                /*
                <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '2em' }}>
                <FormattedMessage id="audory.apppage.body.head3"/>
            </Header>
            <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '2em' }}>
                <FormattedMessage id="audory.apppage.body.body3"/>
            </p>
<center>
                <Button
                    onClick={() => handleMailTo()}
                    color='green'
                    size='massive'
                    icon
                    labelPosition='left'
                    >
                    <Icon name='mail' />
                    <FormattedMessage id="audory.apppage.body.CTA"/>
                </Button>
            </center>

                */
            }
            
                
        </Container>
    </Segment>
  </DivWrapper>
)



export default AppPage;


// WEBPACK FOOTER //
// ./src/components/AppPage.js